import apiClient from "../../utils/apiClient";

export const AddwalletMoney = (params) => {
  return apiClient.post(`/setups/wallet/recharge`, {
    userId: params.userId,
    amount: params.amount,
    paymentMode: params.paymentMode,
    transactionId: params.transactionId,
    createdBy: params.userId,
    referenceId: params.referenceId,
    referenceType: params.referenceType,
    paymentStatus: params.paymentStatus,
    razorpay_payment_id: params.razorpay_payment_id,
  });
};

export const walletHistory = (data) => {
  console.log("see the data", data);
  return apiClient.get(
    `setups/wallet/summary?userId=${data?.userId}&limit=${data?.limit}&offset=${data.offset}`,
  );
};
